<template>
<div>

  <!--  -->
  <footer class="footer  ">
    
    <div class="container container-lg">
      <Contacto/>
      <hr/>
      <div id="pyme-innovadora">
        <h4>Certificado del fabricante: <br/>Humano Software S.L.</h4>
        <img width="300" height="auto" src="/img/pyme_innovadora_meic-SP_web.png"/>
      </div>
      <hr />
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-4">
          <div class="copyright">
            &copy; 2021 
            <router-link to="https://notin.es" target="_blank">NOTIN.es</router-link>. 
            <a href="#/avisolegal" target="_blank">Aviso legal</a>&nbsp;
          </div>
        </div>
        <div class="col-md-4">
          <ul class="nav nav-footer justify-content-md-center">
          <li class="nav-item">
            <a class="nav-link nav-link-icon" href="https://www.facebook.com/DNotin" target="_blank">
              <i class="fa fa-facebook-square"></i>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link nav-link-icon" href="https://twitter.com/Notin_es" target="_blank">
              <i class="fa fa-twitter"></i>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link nav-link-icon" href="https://www.linkedin.com/company/notin.net" target="_blank">
              <i class="fa fa-linkedin"></i>
            </a>
          </li>
        </ul>
        </div>
        <div class="col-md-4">
          <ul class="nav nav-footer justify-content-md-end">
            <li class="nav-item">
              <a href="#/protecciondatos" target="_blank">Protección de datos&nbsp;&nbsp;</a>
            </li>
            <li class="nav-item">
              <a href="#/cookies" target="_blank">Cookies&nbsp;</a>
            </li>
            <li class="nav-item">
              <a href="https://notin.freshteam.com/jobs" target="_blank">Empleos&nbsp;</a>
            </li>
            <li class="nav-item">
              <a href="https://aula.notin.es&utm_source=notin-web&utm_medium=footer" target="_blank">Aula</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</div>
</template>
<script>
import Contacto from '../components/Contacto.vue'
export default {
  name: "AppFooter",
  components: {Contacto},
};
</script>
<style>
#pyme-innovadora{
  margin: 0 auto;
  width: 300px;
  text-align: center;
}
</style>
